export default {
  resendId: 'Encomendar id para reapresentação',
  resendBtn: 'reenviar encomenda',
  newVerSoft: 'enviar informação sobre uma nova versão da aplicação',
  menu: 'Menu',
  thumbs: 'gerar miniaturas',
}
